import { Link } from "react-router-dom";
import { Icon } from "../../components/Icon";
import { usePrices } from "../../api/queries";
import { haptic } from "../../telegram/haptics";
import { formatToman } from "../../i18n/format";
import { useT } from "../../i18n/strings";
import type { PriceKey } from "../../api/types";
import s from "./prices.module.css";

const HEADLINE: PriceKey[] = ["gold_18", "coin_emami"];

/** Two rates under the masthead; the tab holds the whole board. */
export function PriceStrip() {
  const t = useT();
  const prices = usePrices();
  const board = prices.data;
  if (!board) return null;

  const items = HEADLINE.flatMap((key) => {
    const item = board.items[key];
    return item ? [{ key, item }] : [];
  });
  if (!items.length) return null;

  return (
    <Link to="/prices" className={s.strip} onClick={() => haptic.tap()}>
      {items.map(({ key, item }) => (
        <span key={key} className={s.stripItem}>
          <span className={s.stripLabel}>{t.prices.items[key]}</span>
          <span className={s.stripValue}>
            <span className={s.figure}>{formatToman(item.price)}</span>
            <span className={s.amountUnit}>{t.prices.toman}</span>
          </span>
        </span>
      ))}
      <span className={s.stripTail}>
        {board.stale && <span className={s.staleDot} aria-label={t.prices.stale} />}
        <Icon name="forward" size={16} />
      </span>
    </Link>
  );
}
